const EmojiMocha = {}

EmojiMocha.EMOTICON_TEXTS = [
  ':d', ':-)', ':x', '[dizzy]', ':-(',
  ':p', '[crazy]', '[hum]', '[cute]', '[angry]',
  '[sweat]', ':)', '[sleepy]', ':$', '[razz]',
  '[cool]', '[bad luck]', ':O', '[curse]', '[contempt]',
  '[booger]', '[lust]', '[clap]', ':(', '[think]',
  '[sick]', ':*', '[hug]', '[supercilious]', '[right hum]',
  '[left hum]', '[quiet]', '[grievance]', '[yawn]', '[beat]',
  ':?', ';)', '[shy]', '[gonna cry]', ':h',
  '[silent]', '[strong]', '[weak]', '[awesome]', '[meaningless]',
  '[onlooker]', '[mighty]', '[camera]', '[car]', '[plane]',
  '[love]', '[ultraman]', '[rabbit]', '[panda]', '[no]',
  '[ok]', '[like]', '[tempt]', '[yeah]', '[love u]',
  '[fist]', '[poor]', '[shake hand]', '[rose]', '<3',
  '[broken heart]', '[pig]', '[coffee]', '[mic]', '[moon]',
  '[sun]', '[beer]', '[adorable]', '[gift]', '[follow]',
  '[clock]', '[bike]', '[cake]', '[scarf]', '[glove]',
  '[snow]', '[snowman]', '[hat]', '[leaf]', '[football]',
]

EmojiMocha.EMOTICON_KEYS = [
  '001', '002', '003', '004', '005',
  '006', '007', '008', '009', '010',
  '011', '012', '013', '014', '015',
  '016', '017', '018', '019', '020',
  '021', '022', '023', '024', '025',
  '026', '027', '028', '029', '030',
  '031', '032', '033', '034', '035',
  '036', '037', '038', '039', '040',
  '041', '042', '043', '044', '045',
  '046', '047', '048', '049', '050',
  '051', '052', '053', '054', '055',
  '056', '057', '058', '059', '060',
  '061', '062', '063', '064', '065',
  '066', '067', '068', '069', '070',
  '071', '072', '073', '074', '075',
  '076', '077', '078', '079', '080',
  '081', '082', '083', '084', '085',
]

EmojiMocha.EMOTICON_MAPS = {
  ":d": "001", ":D": "001", ":-)": "002", ":x": "003", ":X": "003", "[dizzy]": "004", ":-(": "005",
  ":p": "006", ":P": "006", "[crazy]": "007", "[hum]": "008", "[cute]": "009", "[angry]": "010",
  "[sweat]": "011", ":)": "012", "[sleepy]": "013", ":$": "014", "[razz]": "015",
  "[cool]": "016", "[bad luck]": "017", ":O": "018", "[curse]": "019", "[contempt]": "020",
  "[booger]": "021", "[lust]": "022", "[clap]": "023", ":(": "024", "[think]": "025",
  "[sick]": "026", ":*": "027", "[hug]": "028", "[supercilious]": "029", "[right hum]": "030",
  "[left hum]": "031", "[quiet]": "032", "[grievance]": "033", "[yawn]": "034", "[beat]": "035",
  ":?": "036", ";)": "037", "[shy]": "038", "[gonna cry]": "039", ":h": "040",
  "[silent]": "041", "[strong]": "042", "[weak]": "043", "[awesome]": "044", "[meaningless]": "045",
  "[onlooker]": "046", "[mighty]": "047", "[camera]": "048", "[car]": "049", "[plane]": "050",
  "[love]": "051", "[ultraman]": "052", "[rabbit]": "053", "[panda]": "054", "[no]": "055",
  "[ok]": "056", "[like]": "057", "[tempt]": "058", "[yeah]": "059", "[love u]": "060",
  "[fist]": "061", "[poor]": "062", "[shake hand]": "063", "[rose]": "064", "<3": "065",
  "[broken heart]": "066", "[pig]": "067", "[coffee]": "068", "[mic]": "069", "[moon]": "070",
  "[sun]": "071", "[beer]": "072", "[adorable]": "073", "[gift]": "074", "[follow]": "075",
  "[clock]": "076", "[bike]": "077", "[cake]": "078", "[scarf]": "079", "[glove]": "080",
  "[snow]": "081", "[snowman]": "082", "[hat]": "083", "[leaf]": "084", "[football]": "085"
}

const createRegexFromArray = (arr) => {
  // Escape special characters in each array element 
  const escapedArray = arr.map((element) => {
    return element.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  });
  // Join array elements with "|" 
  const joinedRegex = escapedArray.join('|');
  return joinedRegex;
}

EmojiMocha.getRegex = () => {
  return /(\:d|\:D|\:\-\)|\:x|\:X|\[dizzy\]|\:\-\(|\:p|\:P|\[crazy\]|\[hum\]|\[cute\]|\[angry\]|\[sweat\]|\:\)|\[sleepy\]|\:\$|\[razz\]|\[cool\]|\[bad luck\]|\:O|\[curse\]|\[contempt\]|\[booger\]|\[lust\]|\[clap\]|\:\(|\[think\]|\[sick\]|\:\*|\[hug\]|\[supercilious\]|\[right hum\]|\[left hum\]|\[quiet\]|\[grievance\]|\[yawn\]|\[beat\]|\:\?|\;\)|\[shy\]|\[gonna cry\]|\:h|\[silent\]|\[strong\]|\[weak\]|\[awesome\]|\[meaningless\]|\[onlooker\]|\[mighty\]|\[camera\]|\[car\]|\[plane\]|\[love\]|\[ultraman\]|\[rabbit\]|\[panda\]|\[no\]|\[ok\]|\[like\]|\[tempt\]|\[yeah\]|\[love u\]|\[fist\]|\[poor\]|\[shake hand\]|\[rose\]|\<3|\[broken heart\]|\[pig\]|\[coffee\]|\[mic\]|\[moon\]|\[sun\]|\[beer\]|\[adorable\]|\[gift\]|\[follow\]|\[clock\]|\[bike\]|\[cake\]|\[scarf\]|\[glove\]|\[snow\]|\[snowman\]|\[hat\]|\[leaf\]|\[football\])/
}

export default EmojiMocha
